import { useMount } from 'ahooks';

import { $gt, VueCtxStore } from '@/common/appCtx';

const updateBreadcrumb = () => {
  const breadcrumb = [
    { link: undefined, title: $gt('Workforce Management') },
    {
      link: '/workstation-information',
      title: $gt('Workstation'),
    },
    {
      link: undefined,
      title: $gt('Workstation Log'),
    },
  ];
  VueCtxStore.dispatch('sharedBreadcrumb/updateBreadcrumb', breadcrumb);
};

export const useInitBreadcrumb = () => {
  useMount(updateBreadcrumb);
};
